import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reset-password-success',
  templateUrl: './reset-password-success.html',
  styleUrl: './reset-password-success.scss',
})
export class ResetPasswordSuccess {
  private router = inject(Router);

  goToLogin() {
    this.router.navigate(['/login'], { replaceUrl: true });
  }
}
